// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__T3suQ","filesListContainer":"PosDisputesFiles_filesListContainer__RnHsY","filesButton":"PosDisputesFiles_filesButton__t_jJP"};